import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function AuthUnauthorizedListener() {
  const navigate = useNavigate();
  useEffect(() => {
    const handler = (e: Event) => {
      const redirect = (e as CustomEvent).detail?.redirect ?? '/';
      const search = new URLSearchParams();
      search.set('redirect', redirect);
      navigate(`/login?${search.toString()}`);
    };
    window.addEventListener('auth:unauthorized', handler);
    return () => window.removeEventListener('auth:unauthorized', handler);
  }, [navigate]);
  return null;
}
